import { useEffect } from 'react';
import {
  markProductSwitchPending,
  PRODUCT_SWITCH_KEY,
} from 'utils/CrossTabProductSwitch';

const useCrossTabProductSwitchListener = () => {
  useEffect(() => {
    const handleStorage = (e: StorageEvent) => {
      if (e.key === PRODUCT_SWITCH_KEY && e.newValue != null) {
        markProductSwitchPending();
        window.location.reload();
      }
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);
};

export default useCrossTabProductSwitchListener;
